"use strict";

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveConfig;

var _mergeWith = _interopRequireDefault(require("lodash/mergeWith"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _defaults = _interopRequireDefault(require("lodash/defaults"));

var _map = _interopRequireDefault(require("lodash/map"));

var _toPath = _interopRequireDefault(require("lodash/toPath"));

var _negateValue = _interopRequireDefault(require("./negateValue"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var configUtils = {
  negative: function negative(scale) {
    return Object.keys(scale).filter(function (key) {
      return scale[key] !== '0';
    }).reduce(function (negativeScale, key) {
      return _objectSpread({}, negativeScale, _defineProperty({}, "-".concat(key), (0, _negateValue.default)(scale[key])));
    }, {});
  }
};

function value(valueToResolve) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (0, _isFunction.default)(valueToResolve) ? valueToResolve.apply(void 0, args) : valueToResolve;
}

function mergeExtensions(_ref) {
  var extend = _ref.extend,
      theme = _objectWithoutProperties(_ref, ["extend"]);

  return (0, _mergeWith.default)(theme, extend, function (themeValue, extensions) {
    if (!(0, _isFunction.default)(themeValue) && !(0, _isFunction.default)(extensions)) {
      return _objectSpread({}, themeValue, {}, extensions);
    }

    return function (resolveThemePath, utils) {
      return _objectSpread({}, value(themeValue, resolveThemePath, utils), {}, value(extensions, resolveThemePath, utils));
    };
  });
}

function resolveFunctionKeys(object) {
  var resolveThemePath = function resolveThemePath(key, defaultValue) {
    var path = (0, _toPath.default)(key);
    var index = 0;
    var val = object;

    while (val !== undefined && val !== null && index < path.length) {
      val = val[path[index++]];
      val = (0, _isFunction.default)(val) ? val(resolveThemePath, configUtils) : val;
    }

    return val === undefined ? defaultValue : val;
  };

  return Object.keys(object).reduce(function (resolved, key) {
    return _objectSpread({}, resolved, _defineProperty({}, key, (0, _isFunction.default)(object[key]) ? object[key](resolveThemePath, configUtils) : object[key]));
  }, {});
}

function resolveConfig(configs) {
  return (0, _defaults.default).apply(void 0, [{
    theme: resolveFunctionKeys(mergeExtensions((0, _defaults.default).apply(void 0, [{}].concat(_toConsumableArray((0, _map.default)(configs, 'theme')))))),
    variants: function (firstVariants) {
      return Array.isArray(firstVariants) ? firstVariants : (0, _defaults.default).apply(void 0, [{}].concat(_toConsumableArray((0, _map.default)(configs, 'variants'))));
    }((0, _defaults.default).apply(void 0, [{}].concat(_toConsumableArray((0, _map.default)(configs)))).variants)
  }].concat(_toConsumableArray(configs)));
}